import { Model, Attr, BelongsTo, HasMany } from 'spraypaint';
import User from './auth/User';
import Rendition from './Rendition';
import ApplicationRecord from './ApplicationRecord';
import moment from 'moment';

@Model()
export default class Media extends ApplicationRecord {
  static jsonapiType = 'media';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
      },
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Created Date',
        value: 'created',
        width: 180,
      },
    ];
  }

  static scopeFactory() {
    return Media.includes([]);
  }

  static defaultOptions() {
    return {
      sortBy: ['created'],
      sortDesc: [true],
    };
  }

  @Attr() created: string;
  @Attr() image: string;
  @Attr() thumbnail: string;
  @Attr() media: string;
  @Attr() name: string;
  @Attr() metadata: any;
  @Attr() mediaType: 'video' | 'image' | 'other';

  @BelongsTo() creator: User;
  @HasMany() renditions: Rendition[];

  get formattedDate() {
    if (!this.created) {
      return;
    }
    return moment(this.created).format('MMM D, YYYY h:mm a');
  }

  getRendition(size: string) {
    if (!size) {
      return;
    }

    const image = this.renditions.find(r => r.resolution === size);

    return image ? image.image : '';
  }
}
